<template>
  <unicom-modal
    v-model="mostrar"
    :largura="616"
    fechar
    @input="valor => fecharModal(valor)"
  >
    <div slot="header" class="pb-2">
      <div class="titulo negrito cor-fonte fonte-primaria">
        Selecionar analista
      </div>
    </div>
    <div slot="body">
      <div class="corpo-pesquisa">
        <ContainerPesquisa
          @input-check="inputCheck"
          :colunasPesquisaProp="listagemAnalista"
          :idUsuarioUnimedGiu="idUsuarioUnimedGiu"
        />
      </div>
    </div>
    <div slot="footer">
      <unicom-linha justificarItem="end">
        <unicom-coluna sm="12" md="auto" :order="$breakpoint.smAndDown ? 1 : 0">
          <unicom-botao
            class="fonte-secundaria texto"
            @click="$emit('input', false)"
            :altura="40"
            contornado
            :largura="172"
            :bloco="$breakpoint.smAndDown"
          >
            VOLTAR
          </unicom-botao>
        </unicom-coluna>
        <unicom-coluna sm="12" md="auto" class="pb-2">
          <unicom-botao
            class="fonte-secundaria texto"
            @click="salvar"
            :altura="40"
            :largura="172"
            :bloco="$breakpoint.smAndDown"
            :desabilitado="
              checkModal.length !== 1 || checkModal[0] === idUsuarioUnimedGiu
            "
          >
            VINCULAR ANALISTA
          </unicom-botao>
        </unicom-coluna>
      </unicom-linha>
    </div>
  </unicom-modal>
</template>

<script>
import ContainerPesquisa from "./ContainerPesquisa";
export default {
  components: {
    ContainerPesquisa
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    tipoAcao: {
      type: String,
      default: "adicionar"
    },
    idUsuarioUnimedGiu: {
      type: Number,
      default: null
    },
    listagemAnalista: {
      type: Array,
      default: () => [
        // {
        // "cdUnimed": Number,
        // "email": String,
        // "idUsuarioUnimed": Number,
        // "login": String,
        // "nome": String
        // }
      ]
    }
  },
  data() {
    return {
      mostrar: this.value,
      checkModal: []
    };
  },
  methods: {
    inputCheck(arr) {
      this.checkModal = arr;
    },
    fecharModal(valor) {
      if (!valor) {
        this.limparModal();
        this.$emit("input", false);
      }
    },
    salvar() {
      let objetoAnalista = this.listagemAnalista.find(
        e => e.idUsuarioUnimed === this.checkModal[0]
      );
      this.$emit("salvar-modal", { objetoAnalista, tipoAcao: this.tipoAcao });
      this.fecharModal();
    },
    limparModal() {
      this.checkModal = [];
    }
  },
  watch: {
    value() {
      this.mostrar = this.value;
    }
  }
};
</script>

<style lang="scss" scoped>
.corpo-pesquisa {
  min-height: 282px;
}
</style>
